import { getError } from "@/utils/helpers";
import LchartResultService from "@/services/lchart/LchartResultService";

export const namespaced = true;

export const state = {
  dlightstoremodules: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_ASTORE(state, dlightstoremodules) {
    state.dlightstoremodules = dlightstoremodules;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getAmodule({ commit }, id) {
    commit("SET_LOADING", true);

    LchartResultService.getDchartModuleResult(id)
      .then((response) => {
        commit("SET_ASTORE", response.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_STATEMENTS", []);
  },
};
export const getters = {
  dlightstoremodules: (state) => {
    return state.dlightstoremodules;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
